/* constants */
import extenso from "@/constants/dataExtenso"

/* filter */
import { filterDate } from "@/filters/filters"

class DataExtensoHelper {
  static dataExtenso (data) {
    if (!data) {
      return
    }

    let data_extenso = []
    let data_extenso_string = ''
    let data_string = filterDate(data)
    let data_obj = data_string.split('/')

    let dia = parseFloat(data_obj[0])
    let mes = parseFloat(data_obj[1])
    let ano = data_obj[2]

    for (let i in ano) {
      if (i == 2 && ano[i] == 1) {
        data_extenso[2] = extenso.casadez[ano[2] + ano[3]]
        break
      }
      if (i == 2 && ano[i] == 0) {
        data_extenso[2] = extenso.unidades[ano[3]]
        break
      }

      switch (i) {
        case '0':
          data_extenso[0] = extenso.unidadesMil[ano[i]]
          break
        case '1':
          data_extenso[1] = extenso.centenas[ano[i]]
          break
        case '2':
          data_extenso[2] = extenso.dezenas[ano[i]]
          break
        case '3':
          data_extenso[3] = extenso.unidades[ano[i]]
          break
      }
    }
    data_extenso_string += extenso.dias[dia]
    data_extenso_string += ' de ' + extenso.meses[mes]
    data_extenso_string += ' de ' + this.tratarExtenso(data_extenso)

    return data_extenso_string
  }

  static tratarExtenso (arr) {
    if (arr.length < 3) {
      return
    }
    let string_extenso = ''

    if (arr[0] == '') {
      string_extenso = arr[0] + 'mil'
    } else {
      string_extenso = arr[0] + ' mil'
    }

    for (let i in arr) {
      if (arr[i] != "" && i == 1) {
        string_extenso += ' ' + arr[i]
      }
      if (i != 0 && arr[i] != "" && i != 1) {
        string_extenso += ' e ' + arr[i]
      }
    }

    return string_extenso
  }

  static horaExtenso (horario) {
    let hora = horario.split(':')[0]
    let minuto = horario.split(':')[1]
    let segundo = horario.split(':')[2]

    const tempo = [
      this.horasExtenso(hora),
      this.minutosExtenso(minuto),
      (segundo && segundo != 0) && this.segundosExtenso(segundo),
    ]
    if (!tempo[2]) {
      return `${tempo[0]} ${tempo[1] ? 'e ' + tempo[1] : ''}`.replace(',', '')
    }
    if (!tempo[1]) {
      return `${tempo[0]}`.replace(',', '')
    }
    return tempo.join(' e ')
  }

  static horasExtenso (hora) {
    let horaExtenso
    if (hora[0] >= 2) {
      const h1 = extenso.dezenas[hora[0]]
      const h2 = hora[1] != 0 ? extenso.unidadesHoras[hora[1]] : ''
      horaExtenso = `${h1} ${ h2 ? 'e ' + h2 : '' }`
    } else if (hora[0] == 1) {
      horaExtenso = `${extenso.casadez[hora]}`
    } else if (hora[0] == 0 && hora[1] != 0) {
      const h1 = parseInt(hora[1])
      horaExtenso = `${extenso.unidadesHoras[h1]}`
    } else if (hora[0] == 0 && hora[1] == 0) {
      const h1 = parseInt(hora[1])
      horaExtenso = `${extenso.unidadesHoras[h1]}`
    }
    return `${horaExtenso} ${ parseInt(hora) > 1 ? ' horas, ' : ' hora,' }`
  }

  static minutosExtenso (minuto) {
    let minutoExtenso

    if (+minuto === 0) {
      return ''
    }

    if (minuto[0] >= 2) {
      const m1 = extenso.dezenas[minuto[0]]
      const m2 = extenso.unidades[minuto[1]]
      minutoExtenso = `${m1} ${ m2 ? `e ${ m2 }` : '' }`
    } else if (minuto[0] == 1) {
      minutoExtenso = extenso.casadez[minuto]
    } else if (minuto[0] == 0 && minuto[1] != 0) {
      const m1 = parseInt(minuto[1])
      minutoExtenso = `${extenso.unidades[m1]}`
    } else {
      minutoExtenso = extenso.unidades[minuto]
    }
    return `${minutoExtenso} ${ parseInt(minuto) > 1 ? 'minutos' : 'minuto' }`
  }

  static segundosExtenso (segundo) {
    let segundoExtenso
    if (segundo[0] > 2) {
      const s1 = extenso.dezenas[segundo[0]]
      const s2 = extenso.unidades[segundo[1]]
      segundoExtenso = `e ${s1} ${ s2 ? `e ${ s2 }` : '' }`
    } else if (segundo[0] == 1) {
      segundoExtenso = extenso.casadez[segundo]
    } else if (segundo[0] == 0 && segundo[1] != 0) {
      const s1 = parseInt(segundo[1])
      segundoExtenso = extenso.unidades[s1]
    }

    return `e ${segundoExtenso} segundos`
  }
}

export default DataExtensoHelper
